export default [
    {
        path: '/recall/list',
        name: 'recall_list',
        component: () => import('@src/recall/recall-list.vue'),
        meta: {
            title: 'Rückrufe',
            role: 'ROLE_LIST_RECALL',
        },
    },
    {
        path: '/recall/:id?',
        name: 'recall',
        component: () => import('@src/recall/recall.vue'),
        props(route) {
            return { id: route.params.id ? Number.parseInt(route.params.id) : null };
        },
        meta: {
            title: 'Rückruf bearbeiten',
            role: 'ROLE_EDIT_RECALL',
        },
    },
];
